import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { getAuthToken } from './authToken';

// Raport sprawy: fakty o zamowieniu z rozmowy (Allegro na zywo + OK) + streszczenie i propozycja odpowiedzi (AI).
const auth = () => ({ Authorization: 'Bearer ' + getAuthToken() });
const d = (s?: string | null, time = true) => {
  if (!s) return '—';
  const x = new Date(s);
  if (isNaN(x.getTime())) return String(s);
  return x.toLocaleString('pl-PL', time ? { day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit' } : { day: '2-digit', month: '2-digit', year: '2-digit' });
};
const zl = (v: any, c?: string) => (v == null || v === '' ? '—' : Number(v).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ' + (c || 'PLN'));
const box: any = { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 12, marginBottom: 10 };
const h: any = { fontSize: 12, fontWeight: 700, color: '#374151', marginBottom: 6, textTransform: 'uppercase', letterSpacing: 0.3 };
const row: any = { fontSize: 13, color: '#374151', padding: '2px 0', lineHeight: 1.5 };
const btn: any = { padding: '5px 12px', borderRadius: 6, border: '1px solid #d1d5db', background: '#fff', fontSize: 12, cursor: 'pointer' };

export default function CaseReport({ kind, id, onClose, onInsert, onDraft, hint }: { kind: 'message' | 'issue'; id: string; onClose: () => void; onInsert?: (t: string) => void; onDraft?: (t: string) => void; hint?: string }) {
  const [orderId, setOrderId] = useState<string>('');
  const [f, setF] = useState<any>(null);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(true);
  const [ai, setAi] = useState<any>(null);
  const [aiErr, setAiErr] = useState('');
  const [aiLoading, setAiLoading] = useState(false);
  const isMobile = window.innerWidth < 768;

  // Raport + odpowiedz: jesli dla tego stanu sprawy odpowiedz juz byla wygenerowana (Generuj odpowiedz AI) - pokazujemy ja;
  // jesli nie - raport dziala jak Generuj: tworzy odpowiedz modelem firmy i wstawia ja do pola odpowiedzi.
  const loadAi = (oid: string, refresh?: boolean) => {
    setAiLoading(true); setAiErr('');
    axios.post('/api/case-report/draft', { kind, id, order_id: oid || null, refresh: !!refresh, reuse: !refresh, hint: hint || '' }, { headers: auth(), timeout: 180000 })
      .then((r: any) => {
        const x = r.data || {};
        const rep = x.report || {};
        setAi({ ...rep, reply: x.draft || '', draft_model: x.model || '', draft_cached: !!x.cached, inserted: !x.cached && !!x.draft && !!onDraft });
        if (!x.cached && x.draft && onDraft) onDraft(x.draft);
      })
      .catch((e: any) => setAiErr((e.response && e.response.data && e.response.data.detail) || 'Nie udało się przygotować streszczenia'))
      .finally(() => setAiLoading(false));
  };
  const load = (oid: string) => {
    setLoading(true); setErr(''); setAi(null);
    axios.get('/api/case-report', { headers: auth(), params: oid ? { kind, id, order_id: oid } : { kind, id }, timeout: 90000 })
      .then((r: any) => { setF(r.data); if (r.data && r.data.order) loadAi(oid || r.data.order.id); else loadAi(oid); })
      .catch((e: any) => setErr((e.response && e.response.data && e.response.data.detail) || 'Nie udało się przygotować raportu'))
      .finally(() => setLoading(false));
  };
  useEffect(() => { setOrderId(''); load(''); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, [kind, id]);

  const o = f && f.order;
  const ok = o && o.ok;
  const cust = (f && f.customer) || {};
  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 3000, display: 'flex', justifyContent: 'flex-end', background: 'rgba(17,24,39,0.25)' }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: isMobile ? '100%' : 560, maxWidth: '100%', height: '100%', background: '#f9fafb', boxShadow: '-4px 0 16px rgba(0,0,0,0.12)', display: 'flex', flexDirection: 'column', fontFamily: 'system-ui, sans-serif' }}>
        <div style={{ padding: '12px 14px', borderBottom: '1px solid #e5e7eb', background: '#fff', display: 'flex', alignItems: 'center', gap: 8 }}>
          <b style={{ fontSize: 15, flex: 1 }}>📋 Raport sprawy{f && f.context ? ' – ' + f.context.label + ' · ' + f.context.login : ''}</b>
          <button style={btn} onClick={() => load(orderId)}>Odśwież</button>
          <button style={btn} onClick={onClose}>Zamknij</button>
        </div>
        <div style={{ flex: 1, overflowY: 'auto', padding: 12 }}>
          {loading ? <div style={{ ...box, color: '#6b7280', fontSize: 13 }}>Zbieram dane z Allegro i OPENkontakt…</div> : null}
          {err ? <div style={{ ...box, color: '#b91c1c', fontSize: 13 }}>{err}</div> : null}
          {f && !loading ? (
            <>
              <div style={box}>
                <div style={h}>Klient</div>
                <div style={row}>Konto: <b>{f.account}</b> · zamówień na koncie: <b>{cust.orders_on_account ?? '—'}{cust.orders_more ? '+' : ''}</b> · zwrotów: <b>{cust.returns ?? 0}</b> · dyskusji/reklamacji: <b>{cust.issues ?? 0}</b>{cust.claims ? ' (reklamacji ' + cust.claims + ')' : ''}{cust.ppi ? ' · problemów z zakupem: ' + cust.ppi : ''}</div>
                {(f.orders || []).length > 1 ? (
                  <div style={{ marginTop: 6 }}>
                    <span style={{ fontSize: 12, color: '#6b7280' }}>Zamówienie w raporcie ({f.order_choice}): </span>
                    <select value={orderId || (o ? o.id : '')} onChange={(e) => { setOrderId(e.target.value); load(e.target.value); }} style={{ fontSize: 12, padding: '3px 6px', borderRadius: 6, border: '1px solid #d1d5db', maxWidth: '100%' }}>
                      {(f.orders || []).map((x: any) => <option key={x.id} value={x.id}>{d(x.bought_at, false)} · {zl(x.total, x.currency)} · {x.items}</option>)}
                    </select>
                  </div>
                ) : f.order_choice ? <div style={{ fontSize: 12, color: '#6b7280', marginTop: 4 }}>Zamówienie: {f.order_choice}</div> : null}
              </div>

              <div style={{ ...box, borderColor: '#c7d2fe', background: '#eef2ff' }}>
                <div style={h}>Streszczenie i propozycja odpowiedzi (AI)</div>
                {aiLoading ? <div style={{ fontSize: 13, color: '#6b7280' }}>Przygotowuję raport i odpowiedź…</div> : null}
                {aiErr ? <div style={{ fontSize: 13, color: '#b91c1c' }}>{aiErr}</div> : null}
                {ai && !aiLoading ? (
                  <>
                    <div style={{ ...row, whiteSpace: 'pre-wrap' }}>{ai.summary}</div>
                    {ai.open_elsewhere ? <div style={{ ...row, color: '#4b5563' }}><b>Otwarte też gdzie indziej:</b> {ai.open_elsewhere}</div> : null}
                    {ai.next_step ? <div style={{ ...row, color: '#4b5563' }}><b>Co teraz:</b> {ai.next_step}</div> : null}
                    {ai.reply_points ? <div style={{ ...row, color: '#4b5563', whiteSpace: 'pre-wrap' }}><b>Odpowiedź powinna zawierać:</b> {ai.reply_points}</div> : null}
                    {ai.reply ? (
                      <div style={{ marginTop: 8 }}>
                        <div style={{ fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 4 }}>
                          Propozycja odpowiedzi{ai.inserted ? ' (wstawiona do pola odpowiedzi)' : ''}:
                          {ai.draft_model ? <span style={{ fontWeight: 400, color: '#9ca3af' }}> · {ai.draft_model}</span> : null}
                        </div>
                        <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 10, fontSize: 13, whiteSpace: 'pre-wrap' }}>{ai.reply}</div>
                        <div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
                          {onInsert ? <button style={{ ...btn, background: '#1d4ed8', color: '#fff', border: 'none' }} onClick={() => onInsert(ai.reply)}>Wstaw do odpowiedzi</button> : null}
                          <button style={btn} onClick={() => loadAi(orderId || (o ? o.id : ''), true)}>Wygeneruj ponownie</button>
                        </div>
                      </div>
                    ) : <div style={{ ...row, color: '#6b7280', marginTop: 6 }}>Brak wiadomości klienta – nie ma na co odpowiadać.</div>}
                  </>
                ) : null}
              </div>

              {(f.missing || []).length ? <div style={{ ...box, background: '#fffbeb', borderColor: '#fde68a', fontSize: 12, color: '#92400e' }}>{f.missing.map((m: string, i: number) => <div key={i}>⚠ {m}</div>)}</div> : null}

              {o ? (
                <div style={box}>
                  <div style={h}>Zamówienie</div>
                  <div style={row}>
                    {ok && ok.number ? <b>{ok.number}</b> : null}{ok && ok.apilo_id ? ' · Apilo ' + ok.apilo_id : ''}{o.base_id ? ' · Base ' + o.base_id : ''}
                    <span style={{ color: '#6b7280' }}> · Allegro {o.id}</span>
                  </div>
                  <div style={row}>Zakup: {d(o.bought_at)} · {o.status}{o.fulfillment ? ' / ' + o.fulfillment : ''}{ok && ok.status ? ' · status w OK: ' + ok.status : ''}</div>
                  {o.base ? (
                    <div style={{ ...row, background: '#f5f3ff', border: '1px solid #ddd6fe', borderRadius: 6, padding: '4px 8px', margin: '4px 0' }}>
                      <b>Base {o.base.base_order_id}</b>: status <b>{o.base.status || '—'}</b>
                      {(o.base.packages || []).length ? (o.base.packages || []).map((p: any, i: number) => (
                        <div key={i} style={{ fontSize: 12, color: '#4b5563' }}>
                          {p.is_return ? '↩ Przesyłka zwrotna' : '📦 Przesyłka'} {p.courier || ''} {p.number || ''}{p.tracking ? ' – ' + p.tracking : ''}{p.tracking_at ? ' (' + d(p.tracking_at) + ')' : ''}
                          {p.tracking_url ? <> · <a href={p.tracking_url} target="_blank" rel="noreferrer">śledzenie</a></> : null}
                        </div>
                      )) : (o.base.package_nr ? <div style={{ fontSize: 12, color: '#4b5563' }}>📦 {o.base.courier || ''} {o.base.package_nr}</div> : <div style={{ fontSize: 12, color: '#6b7280' }}>brak przesyłki w Base</div>)}
                    </div>
                  ) : null}
                  <div style={row}>Kwota: <b>{zl(o.total, o.currency)}</b>{o.delivery_cost != null ? ' (dostawa ' + zl(o.delivery_cost, o.currency) + ')' : ''} · płatność: {o.payment && o.payment.type ? o.payment.type : '—'}{o.payment && o.payment.paid_at ? ', ' + d(o.payment.paid_at) : ''}</div>
                  <div style={row}>Dostawa: {o.delivery_method || '—'}</div>
                  {o.delivery_time && (o.delivery_time.dispatch || o.delivery_time.from || o.delivery_time.to) ? (
                    <div style={{ ...row, color: '#1e40af' }}>
                      {o.delivery_time.dispatch ? 'Termin wysyłki wg Allegro: ' + d(o.delivery_time.dispatch.from, false) + ' – ' + d(o.delivery_time.dispatch.to, false) + ' · ' : ''}
                      {o.delivery_time.from || o.delivery_time.to ? 'termin dostawy: ' + d(o.delivery_time.from, false) + ' – ' + d(o.delivery_time.to, false) : ''}
                    </div>
                  ) : null}
                  {(o.offers_delivery || []).filter((x: any) => x.shipment_date || x.handling_time || x.additional_info).map((x: any, i: number) => (
                    <div key={'od' + i} style={{ ...row, color: x.shipment_date ? '#b45309' : '#4b5563', fontWeight: x.shipment_date ? 600 : 400 }}>
                      {x.shipment_date ? '⏳ Przedsprzedaż – wysyłka od ' + d(x.shipment_date, false) : 'Czas wysyłki w ofercie: ' + (x.handling_time || '—')}
                      {(o.offers_delivery || []).length > 1 && x.name ? ' (' + String(x.name).slice(0, 40) + ')' : ''}
                      {x.additional_info ? <div style={{ fontWeight: 400, color: '#6b7280', fontSize: 12 }}>{x.additional_info}</div> : null}
                    </div>
                  ))}
                  {(o.items || []).map((x: any, i: number) => <div key={i} style={{ ...row, color: '#4b5563' }}>• {x.qty}× {x.name} – {zl(x.price, o.currency)}</div>)}
                  {o.buyer_message ? <div style={{ ...row, color: '#4b5563' }}>Wiadomość od kupującego: „{o.buyer_message}”</div> : null}
                  {ok && (ok.notes || []).length ? (
                    <div style={{ marginTop: 6 }}>
                      <div style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>Komentarze do zamówienia</div>
                      {ok.notes.map((n: any, i: number) => <div key={i} style={{ ...row, fontSize: 12 }}><span style={{ color: '#6b7280' }}>{d(n.at)} {n.author || ''}:</span> {n.text}</div>)}
                    </div>
                  ) : null}
                </div>
              ) : null}

              {f.money ? (
                <div style={{ ...box, borderColor: f.money.state === 'zwrócono część' ? '#fdba74' : '#e5e7eb' }}>
                  <div style={h}>Pieniądze</div>
                  <div style={row}>Zwrócono <b>{zl(f.money.refunded, f.money.currency)}</b> z {zl(f.money.total, f.money.currency)} – <b>{f.money.state}</b>{f.money.state === 'zwrócono część' && f.money.missing ? ' (różnica ' + zl(f.money.missing, f.money.currency) + ')' : ''}</div>
                  {(f.refunds || []).map((r: any, i: number) => <div key={i} style={{ ...row, fontSize: 12, color: r.status === 'SUCCESS' ? '#374151' : '#9ca3af' }}>• {d(r.at)} · {zl(r.amount, r.currency)} · {r.reason}{r.status !== 'SUCCESS' ? ' · ' + r.status : ''}</div>)}
                </div>
              ) : null}

              <div style={box}>
                <div style={h}>Oś czasu</div>
                {(f.timeline || []).length ? f.timeline.map((e: any, i: number) => (
                  <div key={i} style={{ display: 'flex', gap: 8, fontSize: 12, padding: '3px 0', borderBottom: '1px dashed #f3f4f6' }}>
                    <span style={{ color: '#6b7280', minWidth: 104 }}>{d(e.at)}</span>
                    <b style={{ color: /Zwrot|Reklamacja|Dyskusja/.test(e.what) ? '#b45309' : /Doręczenie|Zwrot dotarł/.test(e.what) ? '#15803d' : '#374151' }}>{e.what}</b>
                    <span style={{ color: '#4b5563', wordBreak: 'break-word' }}>{e.detail}</span>
                  </div>
                )) : <div style={{ fontSize: 12, color: '#6b7280' }}>Brak zdarzeń.</div>}
              </div>

              {(f.shipments || []).length || (f.extra_shipments || []).length ? (
                <div style={box}>
                  <div style={h}>Przesyłki</div>
                  {(f.shipments || []).map((s: any, i: number) => (
                    <div key={i} style={row}>{s.extra ? '➕ Dosyłka: ' : '📦 '}{s.carrier} <span style={{ fontFamily: 'monospace' }}>{s.waybill}</span> · nadana {d(s.sent_at)} · {s.delivered_at ? <b style={{ color: '#15803d' }}>doręczona {d(s.delivered_at)}</b> : (s.last_status || 'brak informacji o doręczeniu')}{s.source ? ' (' + s.source + ')' : ''}</div>
                  ))}
                  {(f.extra_shipments || []).map((x: any, i: number) => (
                    <div key={'e' + i} style={row}>➕ Dosyłka (zamówienie ręczne) <b>{x.order_number}</b> · {d(x.at, false)} · {x.status || ''}{(x.labels || []).length ? ' · etykieta ' + x.labels.join(', ') : ''}</div>
                  ))}
                </div>
              ) : null}

              {(f.returns || []).length ? (
                <div style={box}>
                  <div style={h}>Zwroty od klienta</div>
                  {f.returns.map((r: any, i: number) => (
                    <div key={i} style={row}>↩ {r.reference || 'zwrot'} · {r.status} · zgłoszony {d(r.created_at, false)}{r.parcel ? ' · nadany ' + d(r.parcel.sent_at, false) + ' (' + (r.parcel.carrier || '') + ')' : ''} · {r.delivered_to_us ? <b style={{ color: '#15803d' }}>dotarł do nas {d(r.delivered_to_us)}</b> : 'jeszcze nie dotarł'}{r.items ? <div style={{ color: '#6b7280', fontSize: 12 }}>{r.items}</div> : null}</div>
                  ))}
                </div>
              ) : null}

              {(f.conversations || []).length ? (
                <div style={box}>
                  <div style={h}>Rozmowy z klientem</div>
                  {f.conversations.map((c: any, i: number) => (
                    <div key={i} style={{ ...row, fontSize: 12, fontWeight: c.this ? 600 : 400 }}>
                      {c.this ? '➤ ' : '• '}{c.type}{c.subject ? ': ' + c.subject : ''} · {d(c.last_at, false)}{c.status ? ' · ' + c.status : ''}{c.handled ? ' · zakończona' : ''}{c.same_order ? ' · to samo zamówienie' : ''}
                    </div>
                  ))}
                </div>
              ) : null}
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
}
